module.exports = __webpack_public_path__ + "img/player-ruffle.5bbb3c5e.svg";